import React from "react";

interface FieldProps {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Field: React.FC<FieldProps> = ({
  label,
  helperText,
  error,
  htmlFor,
  required,
  children,
  className = "",
}) => {
  return (
    <div className={`ds-field ${className}`.trim()}>
      {label && (
        <label className="ds-field-label" htmlFor={htmlFor}>
          {label}
          {required && <span className="ds-field-required" aria-hidden="true">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <span className="ds-input-error" role="alert">
          {error}
        </span>
      ) : helperText ? (
        <span className="ds-input-helper">{helperText}</span>
      ) : null}
    </div>
  );
};
